import React from 'react';
import './Patterns.css';

export type BannerTone = 'queued' | 'offline' | 'danger';

export interface BannerProps {
  tone: BannerTone;
  title: string;
  detail?: string;
  actions?: React.ReactNode;
  testId?: string;
}

export const Banner: React.FC<BannerProps> = ({ tone, title, detail, actions, testId }) => {
  const iconClass =
    tone === 'queued'  ? 'bi-cloud-arrow-up'
  : tone === 'offline' ? 'bi-wifi-off'
  :                      'bi-exclamation-triangle-fill';
  return (
    <div
      data-testid={testId ?? 'banner'}
      role={tone === 'danger' ? 'alert' : 'status'}
      className={`pat-banner pat-banner--${tone}`}
    >
      <i className={`bi ${iconClass}`} aria-hidden="true" />
      <div className="pat-banner__body">
        <div className="pat-banner__title">{title}</div>
        {detail && <div className="pat-banner__detail">{detail}</div>}
      </div>
      {actions && <div className="pat-banner__actions">{actions}</div>}
    </div>
  );
};
